import { FC, useMemo } from 'react'
import { NxHeadingSize, NxHeadingType } from './types'

type NxHeadingProps = {
  type?: NxHeadingType
  size?: NxHeadingSize
  className?: string
  children: string | undefined | number | (string | undefined | number)[]
}

const NxHeading: FC<NxHeadingProps> = ({
  type: Heading = 'h1',
  size = 'md',
  className: extraClassName = '',
  children,
}): React.ReactElement => {
  const classes: string = useMemo(
    (): string => `${extraClassName} heading heading--${size}`,
    [extraClassName, size],
  )

  return <Heading className={classes}>{children}</Heading>
}

export default NxHeading
